import PayoutsApi from "@/api/v2/payouts";

// initial state
const state = () => ({
    loading: false,
    loaded: false,
    payouts: [],
});

// getters
const getters = {
    isLoading: (state) => state.loading,
    isLoaded: (state) => state.loaded,
    getRecentPayouts: (state) => state.payouts,
};

// actions
const actions = {
    load ({state, dispatch}) {
        if (state.loaded) {
            return;
        }

        return dispatch('reload');
    },
    reload ({state}) {
        if (state.loading) {
            return;
        }

        state.loading = true;

        const api = new PayoutsApi();

        api.getRecentPayouts().then(response => {
            state.loading = false;
            state.loaded = true;
            state.payouts = response.data.payouts;
        });
    },
};

// mutations
const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
